module.exports = __webpack_public_path__ + "static/media/funil_icon.2f41e184.svg";